import API from '../../../api/axios';

export async function getDashboardOverview({ supplierId }) {
    const { data } = await API.get('/dashboard/overview', {
        params: { supplierId },
    });
    return data?.data || data;
}

export async function getDashboardSalesChartData({ supplierId }) {
    const { data } = await API.get('/dashboard/sales-chart', {
        params: { supplierId },
    });
    return data?.data || data;
}

export async function getDashboardWorldSalesData({ supplierId }) {
    const { data } = await API.get('/dashboard/world-sales', {
        params: { supplierId },
    });
    return data?.data || data;
}

export async function getDashboardLatestBookings({ supplierId }) {
    const { data } = await API.get('/dashboard/latest-bookings', {
        params: { supplierId },
    });

    const result = data?.data || data;
    return Array.isArray(result) ? result : result?.items || [];
}

export async function getDashboardLatestRequests({ supplierId }) {
    const { data } = await API.get('/dashboard/latest-requests', {
        params: { supplierId },
    });

    const result = data?.data || data;
    return Array.isArray(result) ? result : result?.items || [];
}